import { Component, OnInit, Inject, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { EscritoriosService, LoteFaturaService, UsuarioService } from '../shared/services/acordo-ressarcimento/api/services';
import { Observable, of } from 'rxjs';
import { AppComponent } from '../app.component';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Paginacao, LoteFatura, LoteFaturaPaginado } from '../shared/services/acordo-ressarcimento/api/models';
import { LoadingService } from '../shared/services/components/loading.service';
import { ConsultarLoteFaturaService } from './consultar-lote-fatura.service';

@Component({
  selector: 'app-consultar-lote-fatura',
  templateUrl: './consultar-lote-fatura.component.html',
  styleUrls: ['./consultar-lote-fatura.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ConsultarLoteFaturaComponent implements OnInit {
  public formPesquisa: FormGroup;
  public listaEscritoriosFiltro: any[];
  public nomeEscritorioFiltro: any[];
  public lote: LoteFatura;
  public lotePaginado: LoteFaturaPaginado;
  public dadosLote: LoteFatura[];
  public lotes: LoteFatura[];
  public page: Paginacao;
  public selected = '';
  public loadingLista = false;
  public codigoEscritorio: number;
  public nomeEscritorio: string;
  public isEscritorio: boolean;
  public escritorio: any;

  source = [];
  columnsTemplate = [];

  @ViewChild('templateValorLote') private templateValorLote: TemplateRef<any>;
  @ViewChild('templateDetalheLote') private templateDetalheLote: TemplateRef<any>;
  @ViewChild('templateDataVencimento') private templateDataVencimento: TemplateRef<any>;
  @ViewChild('templateDataGeracao') private templateDataGeracao: TemplateRef<any>;

  constructor(
    private formBuilder: FormBuilder,
    private loading: LoadingService,
    public escritorioService: EscritoriosService,
    public loteFaturaService: LoteFaturaService,
    public consultarLoteFaturaService: ConsultarLoteFaturaService,
    public usuarioService: UsuarioService,
    private router: Router,
    @Inject(AppComponent) public appComponent: AppComponent) { }

  ngOnInit() {

    if( sessionStorage.getItem('codigoEscritorio') && sessionStorage.getItem('codigoEscritorio') != "" ) {
        this.codigoEscritorio = JSON.parse(sessionStorage.getItem('codigoEscritorio'));
    }
    this.nomeEscritorio = sessionStorage.getItem('nomeEscritorio');
    this.isEscritorio = JSON.parse(sessionStorage.getItem('isEscritorio'));

    this.columnsTemplate = [
      { prop: 'numeroLote', label: 'N° Lote' },
      { label: 'Valor do Lote', template: this.templateValorLote },
      { label: 'Data do lote', template: this.templateDataGeracao },
      { prop: 'codigoPessoa.nome', label: 'Escritório' },
      { prop: 'qtdParcelas', label: 'Qtde Parcelas' },
      { label: 'Data do vencimento', template: this.templateDataVencimento },
      { prop: 'codigoStatusLote.descricaoStatus', label: 'Status do lote' },
      { label: 'Detalhe Lote', template: this.templateDetalheLote }
    ];

    this.dadosLote = undefined;
    this.lotePaginado = undefined;
    this.lote = undefined;
    this.criarFormPesquisa();

    this.carregarDadosPagina()

    if (this.consultarLoteFaturaService.isRealizaPesquisa
      && this.consultarLoteFaturaService.isRealizaPesquisa() === true
      && this.consultarLoteFaturaService.getParametrosPesquisa) {
      this.consultarLoteFaturaService.setRealizaPesquisa(false);
      this.formPesquisa = this.consultarLoteFaturaService.getFormPesquisa();
      this.pesquisarLote(this.consultarLoteFaturaService.getParametrosPesquisa()['page']);
    }
  }

  private criarFormPesquisa() {
    this.formPesquisa = this.formBuilder.group({
      numeroLote: null,
      ramoSinistro: null,
      anoSinistro: null,
      numeroSinistro: null,
      dataDe: null,
      dataAte: null,
      escritorio: this.nomeEscritorio != null ? this.nomeEscritorio : null,
      codigoEscritorio: null,
      codigoStatus: null,
      valorInicio: null,
      valorFinal: null
    });
  }

  carregarDadosPagina() {
    this.usuarioService.recuperarDadosUsuario().subscribe(result => {

        this.formPesquisa.controls['ramoSinistro'].setValue( result.produto );

        if( result.codigoEscritorio ) {
            this.codigoEscritorio = result.codigoEscritorio;
        }

        if( result.nomeEscritorio ) {
            this.nomeEscritorio = result.nomeEscritorio;
            this.formPesquisa.controls['escritorio'].setValue( result.nomeEscritorio );
        }

        this.isEscritorio = result.flagEscritorio;
    });
  }

  public autoCompleteBuscaEscritorio() {
    return (keyword: any): Observable<any> => {
      this.nomeEscritorioFiltro = [];

      var parametros: EscritoriosService.ObterEscritoriosParams = {
        nomeEscritorio: this.formPesquisa.controls['escritorio'].value,
        codigoRamoSinistro: this.appComponent.codigoRamo
      };

      this.escritorioService.obterEscritorios(parametros).subscribe(
        data => {
          this.listaEscritoriosFiltro = data;
          for (let key in data) {
            this.nomeEscritorioFiltro.push(data[key].nomeEscritorio);
          }
        }
      );
      return of(this.nomeEscritorioFiltro);
    };
  }

  public autoCompleteBuscaEscritorioSelected($event) {
    this.selected = $event;
    for (let key in this.listaEscritoriosFiltro) {
      if (this.listaEscritoriosFiltro[key].nomeEscritorio == this.selected) {
        this.formPesquisa.controls['codigoEscritorio'].setValue(this.listaEscritoriosFiltro[key].codigoEscritorio);
      }
    }
  }

  public limparPesquisa() {
    this.ngOnInit();
  }

  public pesquisarLote(page) {
    this.loading.open();
    this.dadosLote = undefined;
    this.lotePaginado = undefined;
    this.lotes = [];

    if (this.tratarCondicao(this.escritorio) == null && this.isEscritorio === false) {
      this.formPesquisa.controls['codigoEscritorio'].setValue(null);
    }

    var parametros: LoteFaturaService.ObterLotesParams = {
      page: page == undefined ? 0 : page,
      perPage: 10,
      anoSinistro: this.tratarCondicao(this.formPesquisa.value['anoSinistro']),
      codigoEscritorio: this.tratarCondicao(this.formPesquisa.value['codigoEscritorio']),
      numeroLote: this.tratarCondicao(this.formPesquisa.value['numeroLote']),
      numeroSinistro: this.tratarCondicao(this.formPesquisa.value['numeroSinistro']),
      periodoFinal: this.tratarCondicao(this.formPesquisa.value['dataAte']),
      periodoInicial: this.tratarCondicao(this.formPesquisa.value['dataDe']),
      ramoSinistro: this.tratarCondicao(this.formPesquisa.value['ramoSinistro']),
      valorFinal: this.tratarCondicao(this.formPesquisa.value['valorFinal']),
      valorInicial: this.tratarCondicao(this.formPesquisa.value['valorInicio']),
    };

    this.consultarLoteFaturaService.addDadosPesquisa(parametros, this.formPesquisa);

    this.loteFaturaService.obterLotes(parametros).subscribe(response => {
      this.loading.close();
      this.lotePaginado = response;
      this.dadosLote = this.lotePaginado.lotesFatura;
      this.page = this.lotePaginado.paginacao;
      this.loadingLista = false;
      this.source = this.lotePaginado.lotesFatura;
    }, error => {
      this.loading.close();
      const theError: string = error.error.mensagens[2].mensagem;
      this.loadingLista = false;
      this.appComponent.createAlert("Erro ao efetivar consulta!", 'error');
    });
  }

  public paginar(evt) {
    this.pesquisarLote(evt.offset);
  }

  public visualizarDetalhesFatura(numeroLote: number) {
    console.log(numeroLote);
    this.router.navigate(['/detalhe-lote-fatura/' + numeroLote]);
  }

  public gerarRelatorioLote() {

    this.loading.open();

    this.loteFaturaService.obterRelatorioLote(this.dadosLote).subscribe(response => {
      if (response) {
        const blob = new Blob([response], { type: 'application/vnd.ms-excel' });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
        this.appComponent.createAlert('Relatório emitido com sucesso.', 'success');
      }
      this.loading.close();
    }, error => {
      this.loading.close();
      this.loadingLista = false;
      this.appComponent.createAlert('Não foi possível gerar o relatório.', 'error');
    });
  }

  public tratarCondicao(valor: any) {
    if (valor !== undefined && valor !== null && valor === '') {
      return null;
    }
    return valor;
  }

  public tratarValor(valor: any) {
    if (this.formPesquisa.get(valor).value === 0
        ||  this.formPesquisa.get(valor).value === '') {
          this.formPesquisa.get(valor).setValue(null);
      }
  }

}
